import { of } from 'rxjs/observable/of';
import { hasXFlowFromWhiteboardsTouchpointService } from '../../../services/whiteboards-entrypoint-experiment/index.tsx';
import {
	setHasXflowFromWhiteboardsTouchpoint,
	SET_WHITEBOARD_ELIGIBILITY,
} from '../../../state/actions/whiteboards-entrypoint-experiment/index.tsx';
import type { ActionsObservable, MiddlewareAPI } from '../../../state/types.tsx';
import { getCloudId } from '../../../state/selectors/app/index.tsx';
import { getWhiteboardEligibility } from '../../../state/selectors/whiteboards-entrypoint-experiment/index.tsx';

export const loadHasXflowFromWhiteboardsTouchpointEpic = (
	action$: ActionsObservable,
	store: MiddlewareAPI,
) =>
	action$.ofType(SET_WHITEBOARD_ELIGIBILITY).flatMap(() => {
		const cloudId = getCloudId(store.getState());
		const eligibility = getWhiteboardEligibility(store.getState());
		const isCoUse = eligibility?.flow === 'coUse';

		if (isCoUse && cloudId) {
			return hasXFlowFromWhiteboardsTouchpointService(cloudId).map(
				setHasXflowFromWhiteboardsTouchpoint,
			);
		}
		return of(setHasXflowFromWhiteboardsTouchpoint(false));
	});
